import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OpportunityFlagsService } from '@app/opportunities/services/opportunity-flags.service';

@Injectable({
  providedIn: 'root',
})
export class OpportunitiesNewBrowseGuardService implements CanActivate {
  constructor(
    private opportunityFlagsService: OpportunityFlagsService,
    private router: Router
  ) {}

  public canActivate() {
    // Users who aren't in the new browse testing group should not be able to see
    // this route, regardless of other permissions.
    if (this.opportunityFlagsService.useNewOpportunityBrowse) {
      return true;
    }
    // So redirect them to the main browse view.
    return this.router.parseUrl('/career/opportunities/browse');
  }
}
